
import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";
import Breadcrumb from "@/components/Breadcrumb/index.vue";

@Component({
  name: "AppMain",
  components: {
    Breadcrumb,
  },
  computed: {
    key() {
      return this.$route.path + this.$route.query.t;
    },
  },
})
export default class extends Vue {
  private modifiedList = [
    "/Index",
    "/index/",
    '/IndexNew/workIndex',
    '/IndexNew/workIndexs',
    '/IndexNew/dashboard',
    '/IndexNew/indexS',
    '/Agent/index',

    '/System/door',
  ];
  private isSameHome = false;
  private wheight = window.innerHeight;

  @Watch("$route", {
    deep: true,
    immediate: true,
  })
  private onRouteChange(route: Route) {
    this.isSameHome =
      this.modifiedList.filter((val: any) => {
        return this.$route.path === val;
      }).length > 0;
  }
}
